import React from 'react';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

import PaiTextField from 'features/ui/base-components/pai-text-field';
import { BasicActionDialog } from 'features/ui/base-dialogs';

interface Props {
  open: boolean;
  loading: boolean;
  tagName: string;

  handleTagNameChange(event: React.ChangeEvent<HTMLInputElement>): void;
  handleClose(): void;
  handleCreateTag(): void;
}

const CreateTagDialog: React.FC<Props> = ({
  open,
  loading,
  tagName,
  handleTagNameChange,
  handleClose,
  handleCreateTag
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <BasicActionDialog
      open={open}
      loading={loading}
      dialogTitle={t('createTag')}
      maxWidth="xs"
      proceedButtonText={t('create')}
      handleProceed={handleCreateTag}
      proceedButtonDisabled={tagName.trim() === ''}
      cancelButtonText={t('cancel')}
      handleClose={handleClose}
    >
      <Stack spacing={2} className={classes.dialogContent}>
        <PaiTextField
          value={tagName}
          placeholder={t('enterTagNamePlaceholder')}
          onChange={handleTagNameChange}
        />
      </Stack>
    </BasicActionDialog>
  );
};

const useStyles = makeStyles()(() => ({
  dialogContent: {
    // If you want to tweak spacing or text style:
    // marginTop: theme.spacing(1),
    // fontSize: theme.typography.pxToRem(13),
  }
}));

export default CreateTagDialog;
